"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeGraphicsAnnotation = decodeGraphicsAnnotation;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const typeCodes_1 = require("../typeCodes");
const decode_prop_block_1 = require("./decode-prop-block");
const decode_tc31_visual_label_1 = require("./decode-tc31-visual-label");
function decodeGraphicsAnnotation(node, typeCode, path, warnings) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for tc:${typeCode}, got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const props = findAndDecodeLastPropBlock(node, `${path}/props`, warnings);
    const subShape = classifySubShape(typeCode, node, props);
    const coordsContainers = [];
    for (const child of node.children) {
        const bbox = (0, decode_tc31_visual_label_1.readCoordsContainer)(child);
        if (bbox !== null) {
            coordsContainers.push({ node: child, bbox });
        }
    }
    const bbox = coordsContainers[0]?.bbox ?? null;
    const position = coordsContainers[1] === undefined ? null : (0, decode_tc31_visual_label_1.readCadencePosition)(coordsContainers[1].node);
    return {
        kind: 'graphics-annotation',
        typeCode,
        subShape,
        bbox,
        position,
        props,
        raw: node,
    };
}
function classifySubShape(typeCode, node, props) {
    const childCount = node.children.length;
    const hasProp = (name) => (0, decode_prop_block_1.findProp)(props, name) !== null;
    if (typeCode === typeCodes_1.TypeCode.GraphicsImage) {
        return 'image-annotation';
    }
    if (typeCode === typeCodes_1.TypeCode.GraphicsHtml) {
        if (hasProp('GRAPHICS_IMAGE_FILE')) {
            return 'image-annotation';
        }
        if (hasProp('pageTableType')) {
            return 'toc-table-widget';
        }
        if (hasProp('CGTYPE')) {
            return 'standard-html-annotation';
        }
    }
    if (typeCode === typeCodes_1.TypeCode.GraphicsLineArrow) {
        if (hasProp('GRAPHICS_LINE_ARROW_TYPE')) {
            return 'line-arrow';
        }
        if (hasProp('CGTYPE') && childCount === 20) {
            return 'standard-html-annotation';
        }
        if (hasProp('CGTYPE')) {
            return 'generic-graphic-with-cgtype';
        }
    }
    if (typeCode === typeCodes_1.TypeCode.GraphicsCallout) {
        if (hasProp('CGTYPE') && childCount === 20) {
            return 'standard-html-annotation';
        }
        if (hasProp('CGTYPE')) {
            return 'generic-graphic-with-cgtype';
        }
        if (childCount === 10) {
            return 'generic-graphic-no-cgtype';
        }
    }
    return 'unrecognized';
}
function findAndDecodeLastPropBlock(node, path, warnings) {
    for (let i = node.children.length - 1; i >= 0; i--) {
        const child = node.children[i];
        const block = (0, decode_prop_block_1.decodePropBlock)(child, path, []);
        if (block !== null) {
            return (0, decode_prop_block_1.decodePropBlock)(child, path, warnings);
        }
    }
    return null;
}
//# sourceMappingURL=decode-graphics-annotation.js.map